import { Box, Grid, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import DefaultButton from 'components/DefaultButton';
import endImage from '_assets/register/register-end-image.svg';
import MaiaLogo from 'components/MaiaLogo';
import MaiaText from 'components/MaiaText';
import RegisterLayout from 'pages/RegisterLayout';
import routes from 'config/routes';
import useStyles from './styles'

const RegisterEnd = () => {
  const classes = useStyles();
  const history = useHistory();

  const SideComponent = () => (
    <Grid container direction='column' style={{ height: 'auto' }}>
      <Grid container item justifyContent='center'>
        <MaiaLogo />
      </Grid>

      <Grid container item alignItems='center' style={{ height: '80%' }}>
        <Box>
          <Typography className={classes.text} align='center' variant='h3'>
            Félicitation et bienvenue chez <MaiaText /> !
          </Typography>
          <Typography className={classes.text} align='center' variant='h3'>
            Partagez votre passion dès maintenant, mettez en ligne vos services.
          </Typography>
          <Typography className={classes.text} align='center' variant='h3'>
            Faite décoller votre entreprise et rejoignez la communauté des prestataires <MaiaText /> !
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction='column' style={{ height: 'auto' }}>
        <Grid className={classes.header} container item justifyContent='center'>
          <Typography className={classes.title} align='center' variant='h1'>
            BRAVO BIENVENUE CHEZ <br/><br/>
            <MaiaText style={{ fontStyle: 'italic', textTransform: 'uppercase' }}/>
            <span className={classes.tertiaryTitle}> !</span>
          </Typography>
        </Grid>

        <Grid container item alignItems='center' justifyContent='center' style={{ flexGrow: 1 }}>
          <img
            src={endImage}
            style={{ margin: '3em' }}
            alt='register end'
            width={323}
            height={310}
          />
        </Grid>

        <Grid container item alignItems='flex-end' justifyContent='center' style={{ marginBottom: '16px' }}>
          <DefaultButton
            color='secondary'
            variant='contained'
            onClick={() => history.push(routes.home.root)}
          >
            Valider
          </DefaultButton>
        </Grid>
      </Grid>
    </RegisterLayout>
  );
};

export default RegisterEnd;
